import { h } from 'preact'
import {UserData} from '../event/EventAttendees'
import UserAvatar from '../User/UserAvatar'

interface Props {
  members: Array<UserData>
}

const GroupMembers = ({members}: Props) => (
  <div className='widget group-details_description'>
    <div className='group-content-container'>
      <h3 className='widget-title'>Members</h3>
      <div>
        {
          members.map(member => <UserAvatar
            user={member}
            extraClass='thread-list-avatar avatar--responsive'
            showRank
          />)
        }
      </div>
    </div>
  </div>
)

export default GroupMembers
